import React from 'react';
import LikedTracksSection from '../../components/organism/LikedTracksSection/LikedTracksSection';

function MyLikes() {
  return (
    <div>
      <LikedTracksSection />
    </div>
  );
}

export default MyLikes;
